import React from "react";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons

const ArthaMultiSelect = ({ options, value, onChange, placeholder }) => {

  // Custom item template without a checkbox
  const itemTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ fontSize: '12px' }}>
        <span>{option.name}</span>
      </div>
    );
  };

  return (
    <>
      {/* Adding a style tag to override the checkbox color */}
      <style>
        {`
          /* Checkbox base styles */
          .artha-multiselect-panel .p-checkbox-box,
          .custom-multiselect .p-checkbox-box {
            border: 2px solid #fd6816 !important;
            border-radius: 3px !important;
            width: 18px !important;
            height: 18px !important;
          }
          /* Unchecked state */
          .artha-multiselect-panel .p-checkbox-box:not(.p-highlight):not([data-p-highlight="true"]),
          .custom-multiselect .p-checkbox-box:not(.p-highlight):not([data-p-highlight="true"]) {
            background-color: #fff !important;
          }
          /* Checked state - class and data attribute selectors */
          .artha-multiselect-panel .p-checkbox-box.p-highlight,
          .artha-multiselect-panel .p-checkbox-box[data-p-highlight="true"],
          .custom-multiselect .p-checkbox-box.p-highlight,
          .custom-multiselect .p-checkbox-box[data-p-highlight="true"] {
            background-color: #fd6816 !important;
            border-color: #fd6816 !important;
          }
          /* Checkmark icon */
          .artha-multiselect-panel .p-checkbox-icon,
          .custom-multiselect .p-checkbox-icon {
            color: white !important;
          }
          /* Keep native input hidden */
          .artha-multiselect-panel .p-checkbox input[type="checkbox"],
          .custom-multiselect .p-checkbox input[type="checkbox"] {
            opacity: 0 !important;
            position: absolute !important;
          }
        `}
      </style>

      <MultiSelect
        value={value}
        onChange={(e) => onChange(e.value)}
        options={options}
        optionLabel="name"
        itemTemplate={itemTemplate}
        filter
        placeholder={placeholder}
        maxSelectedLabels={3}
        className="custom-multiselect"
        panelClassName="artha-multiselect-panel"
        style={{ height: '30px', alignItems: 'center', width: '200px', fontSize: '12px', border: '1px solid #ced4da', borderRadius: '4px' }}
        filterPlaceholder="Search..."
        panelStyle={{ fontSize: '12px' }}
        inputStyle={{ fontSize: '12px' }}
      />
    </>
  );
};

export default ArthaMultiSelect;
